import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import RoutinePopup from "../Reusable/Routine/Popup/RoutinePopup";

import {
 
  Typography,


} from "@mui/material";

import SectionSlider from "../Reusable/SectionSlider/SectionSlider";
import { sectionsStrategyCreation, sectionsStrategyCreationPaths } from '../../constants/sectionData';
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";

import pdf from '../../assets/images/fileImage/pdf.png'
import image from '../../assets/images/fileImage/image_icon.png'

import GlobalPoliciesFileViewPopup from '../Reusable/Popup/GlobalPoliciesFileViewPopup'
import GPAdminFileViewPopup from '../Reusable/Popup/GPAdminFileViewPopup'
import { apiService } from "../../api/apiService";
import RoutineTabs from "../Reusable/utils/RoutineTabs";
import ChangeManagementPopup from "../Reusable/Routine/Popup/ChangeManagementPopup";
import ValueCreationTabs from "../Reusable/utils/ValueCreationTabs";
import { getFileImagePath } from "../Reusable/utils/fileUtils";
import BusinessCycleAdmiFileViewPopup from "../Reusable/Popup/BusinessCycleAdmiFileViewPopup";
import BusinessCyclePopup from "../Reusable/Routine/Popup/BusinessCyclePopup";
import ValueCreationGbsCrossTabs from "../Reusable/utils/ValueCreationGbsCrossTabs";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';


interface LocationState {
  management?: string;
  id: any;
  // function_l1: any;
  file_name: string;
  created_at: any;
  onClick: (id: any, file_name: string, function_l1: any, created_at: any) => void;
  status: any;
  reason_to_approve: any;
  reason_to_revert: any;

}
interface GbsCrossChargeUploadProps {

  isAdmin?: boolean;
  isManager?: boolean;
  fetchDataApi?:any;
  tabName?:string;
  fileDetailApi?:any;
  statusApi?:any;
  verticalTabs?: { label: string; value: string }[]; // Add this line
  highlightSection ?:any;
  fileTitleMapping?: { // Add this line
    [key: string]: string;
};


  

}

// const verticalTabs = [
//   { label: "T&M Routine - CAPEX", value: "a" },
//   { label: "T&M Routine - OPEX", value: "b" },
//   { label: "People Planning and Performance Management", value: "c" },
//   { label: "People Cost Center master-data", value: "d" },
// ];

const GbsCrossChargeUpload: React.FC<GbsCrossChargeUploadProps> = ({ isAdmin, isManager, fetchDataApi, tabName, fileDetailApi, statusApi, verticalTabs, highlightSection, fileTitleMapping }) => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("1");
  const [verticalTabValue, setVerticalTabValue] = useState("a");
  const [openUpload, setOpenUpload] = useState(false);
  const [open, setOpen] = useState(false);
  const [routineData, setRoutineData] = useState<any[]>([]);



  // const locationState = location.state as LocationState | undefined;
  // const management = locationState?.management || "Default Location Name";
  const management = localStorage.getItem("management") || "Default Location Name";
  const [currentPage, setCurrentPage] = useState(1);
  const [filterValue, setFilterValue] = useState('');
  const [files, setFiles] = useState<LocationState[]>([]);


  const [isPopupOpen, setPopupOpen] = useState(false);

  const [page, setPage] = useState(1);
  const itemsPerPage = 3;
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // const paginatedData = routineData.slice(startIndex, endIndex);

  // Tab Status Logic
  const tabStatuses: { label: string; value: 'All' | 'Pending' | 'Approved' | 'Reverted'; apiStatus: string | null }[] = [
    { label: 'All', value: 'All', apiStatus: null }, // `null` means no filtering (include all statuses)
    { label: 'Pending', value: 'Pending', apiStatus: 'Pending' },
    { label: 'Approved', value: 'Approved', apiStatus: 'Approved' },
    { label: 'Reverted', value: 'Reverted', apiStatus: 'Reverted' },
  ];
  const selectedStatus = tabStatuses.find(tab => String(tabStatuses.indexOf(tab) + 1) === tabValue)?.value;

  // Filter routineData based on the selected tab status
  const filteredRoutineData = selectedStatus === "All"
    ? routineData
    : routineData.filter(item => item.status === selectedStatus);

  const paginatedData = filteredRoutineData.slice(startIndex, endIndex);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const fetchRoutineData = async () => {
    setIsLoading(true);
    try {
      const response = await apiService(
        fetchDataApi,
        "GET",
        {
          management: management,
          section_name: verticalTabs?.find((tab) => tab.value === verticalTabValue)?.label ?? '',
          tab_name: tabName
        },
        undefined, 
        instance as PublicClientApplication
      );

      if (response.data) {
        setRoutineData(response.data); // Update routineData
        setFiles(response.data); // Sync files with the API response
      }
    } catch (error) {
      console.error("Error fetching routine data:", error);

      // Set routineData to null on API failure
      setRoutineData([]);

      // Update the error state
      if (error instanceof Error) {
        setError(error.message || "An error occurred");
      } else {
        setError("An error occurred");
      }

      // Check if the error status is 401 and redirect to /login
      if (error instanceof Error && (error as any).response && (error as any).response.status === 401) {
        navigate('/login');
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
  
    fetchRoutineData();
  }, [verticalTabValue]);

  const handleVerticalTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setVerticalTabValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [selectedFile, setSelectedFile] = useState<{ id: any; file_name: string, created_at: any, status: any, reason_to_approve: any, reason_to_revert: any } | null>(null);



  const handleViewClick = (id: any, file_name: string, created_at: any, status: any, reason_to_approve: any, reason_to_revert: any) => {
    setPopupOpen(true);
    setSelectedFile({ id, file_name, created_at, status, reason_to_approve, reason_to_revert });
  };




  const breadcrumbs = [
    <Link key="1" color="#000" to="/">
      Home
    </Link>,
    <Link key="2" color="#000" to="/operations/strategy-value-creation/" >
      Evidence Upload
    </Link>,
  <Link key="3" to="/operations/strategy-value-creation/">
        Value Creation through resources allocation
      </Link>,
    <Typography key="4" sx={{ fontFamily: 'Avantt' }}>
      {management}
    </Typography>,
  ];


  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    console.log("Tab changed to:", newValue);
    setTabValue(newValue);
  };



  const counts = {
    All: files.length,
    Pending: files.filter((file) => file.status === 'Pending').length,
    Approved: files.filter((file) => file.status === 'Approved').length,
    Reverted: files.filter((file) => file.status === 'Reverted').length,
  };

 


  return (
    <>
      {/* Activity Bar and Section Slider */}
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sectionsStrategyCreation}
        sectionPaths= { sectionsStrategyCreationPaths }
        highlightSection={highlightSection}
        highlightColor="#D7A833"
        defaultColor="#666"
      />


      <ValueCreationGbsCrossTabs
        tabValue={tabValue}
        handleTabChange={handleTabChange}
        tabStatuses={tabStatuses}
        counts={counts}
        verticalTabValue={verticalTabValue}
        
        verticalTabs={verticalTabs || []}
        isLoading={isLoading}
        filteredRoutineData={filteredRoutineData}
        paginatedData={paginatedData}
        routineData={routineData}
        itemsPerPage={itemsPerPage}
        handleChangePage={handleChangePage}
        handleViewClick={handleViewClick}
        setOpenUpload={setOpenUpload}
        getFileImagePath={getFileImagePath}
        handleVerticalTabChange={handleVerticalTabChange}
        isMcrTab={true}
      />


      {/* Upload form section */}
      {/* <GlobalPoliciesPopup openUpload={openUpload} setOpenUpload={setOpenUpload} management={management} verticalTabValue={verticalTabs.find(tab => tab.value === verticalTabValue)?.label} /> */}
      <BusinessCyclePopup openUpload={openUpload} setOpenUpload={setOpenUpload} management={management} verticalTabValue={verticalTabs?.find(tab => tab.value === verticalTabValue)?.label} verticalTabValueTitle={verticalTabValue} onSuccess={fetchRoutineData} fileUploadApi="/strategy/strategy_n_value_creation" payloadKey="value_creation" tabName={tabName} fileTitleMapping={fileTitleMapping}  />

      {/* File View Popup */}
      {isPopupOpen && selectedFile && (
        <>
          {
            isManager && (
              <GlobalPoliciesFileViewPopup
                onClose={handleClosePopup}
                open={true}
                name={selectedFile.file_name}
                id={selectedFile.id}
                // functionl1={selectedFile.function_l1}
                date={selectedFile.created_at}
                sectionTitle={verticalTabs?.find(tab => tab.value === verticalTabValue)?.label || ''}
                // userDetail={true}
                apiPath={`${fileDetailApi}/${selectedFile.id}`} // Pass the API path for file details
                

              />
            )
          }


          {isAdmin && (
            <BusinessCycleAdmiFileViewPopup
              onClose={handleClosePopup}
              open={true}
              name={selectedFile.file_name}
              id={selectedFile.id}
              // functionl1={selectedFile.function_l1}
              date={selectedFile.created_at}
              status={selectedFile.status}
              reason_to_approve={selectedFile.reason_to_approve}
              reason_to_revert={selectedFile.reason_to_revert}
              sectionTitle={verticalTabs?.find(tab => tab.value === verticalTabValue)?.label || ''}
              apiPath={`${fileDetailApi}/${selectedFile.id}`} // Pass the API path for file details
              statusApiPath={`/${statusApi}`}// Pass the API path for status updates
            />
          )}
        </>
      )}

    </>
  );
};

export default GbsCrossChargeUpload;